// 2026-05-14 10:00 Riga (UTC+3) = 07:00 UTC
export const LAUNCH_UTC_MS = Date.parse('2026-05-14T07:00:00Z')
